import React from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookMessengerShareButton,
} from "react-share";

const FollowUs = () => {
  const { t } = useTranslation();
  const shareUrl = window.location.origin;

  return (
    <div className="sidebar_widget">
      <h4>{t("follow us")}</h4>

      <ul className="icon_list_news top_cover">
        <FacebookShareButton url={shareUrl}>
          <li>
            <a href="#" className="fb">
              <i className="fab fa-facebook-f" />
            </a>
          </li>
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl}>
          <li>
            <a href="#" className="twit">
              <i className="fab fa-twitter" />
            </a>
          </li>
        </TwitterShareButton>

        <WhatsappShareButton url={shareUrl}>
          <li>
            <a href="#" className="whatsapp">
              <i class="fab fa-whatsapp"></i>
            </a>
          </li>
        </WhatsappShareButton>
        <FacebookMessengerShareButton url={shareUrl}>
          <li>
            <a href="#" className="twit">
              <i class="fab fa-facebook-messenger"></i>
            </a>
          </li>
        </FacebookMessengerShareButton>
        <EmailShareButton url={shareUrl}>
          <li>
            <a href="#" className="google">
              <i class="fas fa-envelope"></i>
            </a>
          </li>
        </EmailShareButton>
      </ul>
    </div>
  );
};

export default FollowUs;
